import { Buildings, type BuildingDefinition } from "../definitions/buildings";
import { GroupHitbox, RectangleHitbox } from "./hitbox";
import { permanentInteriorWalls } from "./interiorGeometry";
import { FloorNames } from "./terrain";
import { Vec } from "./vector";

/** Room covers are roofs, not stair hatches. Keep their real floor and wall footprint beneath them. */
export function vaultInterior(definition: BuildingDefinition): BuildingDefinition | undefined {
    if (definition.idString !== "headquarters_vault" && definition.idString !== "blue_house_vault") return;
    if (!definition.ceilingHitbox) return;
    const floor = definition.ceilingHitbox.toRectangle();
    const hq = definition.idString === "headquarters_vault";
    const offset = hq ? Vec(58.8, 9.4) : Vec(0, 0);
    const source = hq ? Buildings.fromString("headquarters").hitbox : definition.hitbox;
    const walls = permanentInteriorWalls(source).flatMap(wall => {
        const min = Vec(Math.max(wall.min.x + offset.x, floor.min.x - 2), Math.max(wall.min.y + offset.y, floor.min.y - 2));
        const max = Vec(Math.min(wall.max.x + offset.x, floor.max.x + 2), Math.min(wall.max.y + offset.y, floor.max.y + 2));
        return max.x > min.x && max.y > min.y ? [new RectangleHitbox(min, max)] : [];
    });
    return { ...definition, paintedInterior: true, floors: [{ type: FloorNames.Metal, hitbox: floor }], hitbox: new GroupHitbox(...walls) };
}
